module.exports = require("@vscode/base-node/vs/base/common/arrays");